import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAcneThreeGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 19.031a2.02 2.02 0 0 1-2.02-2.02c0-1.116.904-2.011 2.02-2.011s2.02.904 2.02 2.01c0 1.107-.913 2.021-2.02 2.021Zm0-2.828a.815.815 0 0 0-.818.808.817.817 0 1 0 1.636 0 .815.815 0 0 0-.818-.808Zm13.98 16.616a2.012 2.012 0 0 1-2.011-2.021 2.01 2.01 0 0 1 2.01-2.01c1.107 0 2.021.904 2.021 2.01 0 1.107-.914 2.02-2.02 2.02Zm0-2.83a.807.807 0 0 0-.809.809c0 .452.366.818.809.818a.823.823 0 0 0 .817-.818.828.828 0 0 0-.817-.808ZM8 30.799a2.02 2.02 0 0 0 2.02 2.02c1.107 0 2.011-.913 2.011-2.02a2.01 2.01 0 0 0-2.01-2.01c-1.117 0-2.021.894-2.021 2.01Zm1.203 0c0-.443.365-.808.817-.808.453 0 .809.365.809.808a.809.809 0 0 1-.809.818.817.817 0 0 1-.817-.818Z",
    fill: "currentColor"
  }));
}

export { SvgAcneThreeGlyph as default };
